import { Pipe, PipeTransform } from "@angular/core";
import { MAX_VISIBLE_CHIPS } from "./chip.const";

@Pipe({ name: "visibleChips" })
export class VisibleChipsPipe implements PipeTransform {
  transform<T>(items: T[] | null | undefined, count = MAX_VISIBLE_CHIPS): T[] {
    return (items ?? []).slice(0, count);
  }
}
